<div class="container mt-4">
  <div class="card shadow-sm">
    <div class="table-responsive p-3">

      <!-- Header & ADD Button -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Employee Details</h4>
        <button class="btn btn-primary" (click)="gotoempmaster()">ADD NEW</button>
      </div>
      <!-- Search Box -->
<div class="row mb-3">
  <div class="col-md-4">
    <input type="text"
           class="form-control"
           placeholder="Search Employee..."
           [(ngModel)]="searchText" (input)="filterEmployees()">
  </div>
</div>

      <!-- Employee Table -->
      <div class="table-responsive modern-table-container">
        <table class="table table-bordered table-hover">
          <thead class="table-dark">
            <tr>
              <th>#</th>
              <th>Action</th>
              <th>Emp Code</th>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Designation</th>
              <th>Location</th>
              <th>Department</th>
              <th>Date of Joining</th>
              <th>Phone No</th>
              <th>Checker</th>
            </tr>
          </thead>
          <tbody><!--*ngIf="appservice.employeemasterdata && appservice.employeemasterdata.length > 0"-->
            <tr *ngFor="let emp of employeemasterdatas; let i = index">
              <!-- Index -->
              <td>{{ i + 1 }}</td>

              <!-- Action Dropdown -->
              <td class="text-center">
                <div class="Dropdown">
                  <button class="icon-button me-1" ([ngModel])="appservice.empmastereditid"
                    (click)="editEmployee(emp.Em_iid)" title="Edit">
                    <img src="assets/images/edit.png" alt="Edit" width="20" height="20">
                  </button>
                  <button class="icon-button" (click)="deleteEmployee(emp.Em_iid)" title="Delete">
                    <img src="assets/images/bin2.png" alt="Delete" width="20" height="20">
                  </button>
                </div>
              </td>

              <!-- Data Columns -->
              <td>{{ emp.Em_Empcode }}</td>
              <td>{{ emp.Em_First_Name }}</td>
              <td>{{ emp.Em_lastName }}</td>
              <td>{{ emp.Em_Designation }}</td>
              <td>{{ emp.Em_Grade }}</td>
              <td>{{ emp.Em_Department }}</td>
              <td>{{ emp.Em_DateofJoin }}</td>
              <td>{{ emp.Em_PhoneNo }}</td>
              <td>{{ emp.Em_Checker_Approvedby }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>